/* bangerfabrique theme behaviour
   - SCM music player (local audio file; Spotify embed is an optional later upgrade)
   - swatch / variant selection on the product page
   Kept dependency-free so it works the same in the Shopify theme and in preview.html. */
(function () {
  "use strict";

  /* ---------- SCM music player (playlist; shows current track name) ---------- */
  function initPlayer() {
    var root = document.querySelector("[data-bfq-player]");
    if (!root) return;
    var audio = root.querySelector("audio");
    var playBtn = root.querySelector("[data-bfq-play]");
    var nextBtn = root.querySelector("[data-bfq-next]");
    var fill = root.querySelector(".bfq-player__fill");
    var titleEl = root.querySelector("[data-bfq-track]");
    var dataEl = root.querySelector("[data-bfq-playlist]");
    var iconPlay = "M8 5v14l11-7z";
    var iconPause = "M6 5h4v14H6zM14 5h4v14h-4z";
    if (!audio) return;

    var playlist = [];
    try { playlist = JSON.parse(dataEl ? dataEl.textContent : "[]"); } catch (e) { playlist = []; }
    if (!playlist.length) return;

    var index = 0;

    function setIcon(path) {
      var p = playBtn && playBtn.querySelector("path");
      if (p) p.setAttribute("d", path);
    }
    function label(i) {
      if (titleEl) titleEl.textContent = (playlist[i] && playlist[i].name) || "track";
    }
    function load(i, autoplay) {
      index = (i + playlist.length) % playlist.length;
      var track = playlist[index];
      label(index);
      if (fill) fill.style.width = "0%";
      if (track && track.src) {
        audio.src = track.src;
        if (autoplay) {
          audio.play().then(function () { setIcon(iconPause); }).catch(function () {});
        }
      }
    }

    load(0, false); // show first track name up front, don't autoplay (browsers block it)

    if (playBtn) {
      playBtn.addEventListener("click", function () {
        if (!playlist[index] || !playlist[index].src) return;
        if (audio.paused) {
          audio.play().then(function () { setIcon(iconPause); }).catch(function () {});
        } else {
          audio.pause();
          setIcon(iconPlay);
        }
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener("click", function () { load(index + 1, true); });
    }
    audio.addEventListener("timeupdate", function () {
      if (fill && audio.duration) {
        fill.style.width = ((audio.currentTime / audio.duration) * 100).toFixed(1) + "%";
      }
    });
    audio.addEventListener("ended", function () {
      if (playlist.length > 1) { load(index + 1, true); } else { setIcon(iconPlay); }
    });
  }

  /* ---------- product page: variant / swatch selection ----------
     Clicking a size selects the MATCHING variant in <select name="id"> (the field
     that is actually submitted). Also updates price + the add-to-cart button. */
  function initSwatches() {
    var form = document.getElementById("bfq-buy-form");
    if (!form) return;
    var dataEl = form.querySelector("[data-bfq-variants]");
    var select = form.querySelector("[data-bfq-variant-select]");
    var groups = form.querySelectorAll("[data-bfq-swatches]");
    if (!dataEl || !select || !groups.length) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var priceEl = document.querySelector(".bfq-product__price");
    var buyBtn = form.querySelector(".bfq-buy");
    var selected = []; // selected option value per option index

    function groupIndex(g) { return parseInt(g.getAttribute("data-bfq-option-index") || "0", 10); }

    function matchVariant() {
      return variants.find(function (v) {
        for (var i = 0; i < v.options.length; i++) {
          if (selected[i] !== v.options[i]) return false;
        }
        return true;
      });
    }

    function update() {
      var v = matchVariant();
      if (!v) return;
      select.value = v.id;
      if (priceEl && v.price) priceEl.textContent = v.price;
      if (buyBtn) {
        buyBtn.disabled = !v.available;
        buyBtn.textContent = v.available ? "in den warenkorb" : "ausverkauft";
      }
    }

    groups.forEach(function (group) {
      var idx = groupIndex(group);
      // seed the initial selection from the pre-marked active swatch
      var active = group.querySelector(".bfq-swatch--active") || group.querySelector(".bfq-swatch");
      if (active) selected[idx] = active.dataset.value;

      // grey out sizes whose variant is sold out (single-option safe)
      group.querySelectorAll(".bfq-swatch").forEach(function (b) {
        var soldOut = !variants.some(function (v) { return v.options[idx] === b.dataset.value && v.available; });
        if (soldOut) b.classList.add("bfq-swatch--soldout");
      });

      group.addEventListener("click", function (e) {
        var btn = e.target.closest(".bfq-swatch");
        if (!btn || btn.classList.contains("bfq-swatch--soldout")) return;
        group.querySelectorAll(".bfq-swatch").forEach(function (b) { b.classList.remove("bfq-swatch--active"); });
        btn.classList.add("bfq-swatch--active");
        selected[idx] = btn.dataset.value;
        update();
      });
    });

    update(); // sync select/price/button with the initial selection on load
  }

  /* ---------- background video: cycle through the clips in sequence ---------- */
  function initBackground() {
    var video = document.querySelector(".bfq-bg__video");
    var fallback = document.querySelector(".bfq-bg__fallback");
    if (!video) return;
    if (fallback) video.addEventListener("canplay", function () { fallback.style.display = "none"; });
    var list = [];
    try { list = JSON.parse(video.getAttribute("data-bfq-videos") || "[]").filter(Boolean); } catch (e) { list = []; }
    if (list.length < 2) return; // single clip: keep the native loop attribute

    // start at a random clip so every visit feels different, then rotate in order
    var i = Math.floor(Math.random() * list.length);
    video.loop = false;
    function play(idx) {
      i = (idx + list.length) % list.length;
      video.src = list[i];
      video.load();
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }
    video.addEventListener("ended", function () { play(i + 1); });
    play(i);
  }

  /* ---------- PDP gallery: thumbnails swap the main image ---------- */
  function initGallery() {
    var thumbs = document.querySelector("[data-bfq-thumbs]");
    var main = document.querySelector("[data-bfq-main]");
    if (!thumbs || !main) return;
    thumbs.addEventListener("click", function (e) {
      var btn = e.target.closest(".bfq-thumb");
      if (!btn) return;
      main.src = btn.dataset.full;
      // sticker outline only for the cut-out (first image), not lifestyle photos
      if (btn.dataset.cutout === "1") { main.classList.add("bfq-outline"); }
      else { main.classList.remove("bfq-outline"); }
      thumbs.querySelectorAll(".bfq-thumb").forEach(function (b) { b.classList.remove("is-active"); });
      btn.classList.add("is-active");
    });
  }

  /* ---------- landing/password: reveal the password entry on demand ---------- */
  function initLandingToggle() {
    var toggle = document.querySelector("[data-bfq-pw-toggle]");
    var panel = document.querySelector("[data-bfq-pw]");
    if (!toggle || !panel) return;
    toggle.addEventListener("click", function () {
      var open = panel.hasAttribute("hidden");
      if (open) { panel.removeAttribute("hidden"); } else { panel.setAttribute("hidden", ""); }
      toggle.setAttribute("aria-expanded", String(open));
    });
  }

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }
  ready(function () { initPlayer(); initSwatches(); initBackground(); initGallery(); initLandingToggle(); });
})();
